// extracted by mini-css-extract-plugin
export default {"job":"JobSection_job__UBQua","content":"JobSection_content__j3WLb","jobEmpty":"JobSection_jobEmpty__rhuNu","jobList":"JobSection_jobList__X1Cj9"};